document.addEventListener('variant:change', (event) => {
  const v  = event.detail.variant;
  const el = document.getElementById('InventoryMessage');
  if (!el || !v) return;

  if (v.inventory_management !== 'shopify') {
    el.textContent = '';
    return;
  }

  const qty = v.inventory_quantity;
  let msg   = '';

  if (qty >= 1000)      msg = 'über 1.000 auf Lager';
  else if (qty > 0)     msg = `${qty} auf Lager`;
  else                  msg = 'Nicht auf Lager';

  el.textContent = msg;
});
